<table class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      @if (!hideMID) {
        <th class="no-sort">MID</th>
      }
      <th (click)="sortBy_click('payment_methods.pan_last4')">
        Card {{ this._sortColumn === 'payment_methods.pan_last4' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th (click)="sortBy_click('transactions.create_date')">
        Transaction Date {{ this._sortColumn === 'transactions.create_date' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th (click)="sortBy_click('transaction_types.name')">
        Type {{ this._sortColumn === 'transaction_types.name' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th (click)="sortBy_click('transactions.magnified_amount')">
        Amount {{ this._sortColumn === 'transactions.magnified_amount' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">Customer</th>
      <th class="no-sort">Successful</th>
    </tr>
  </thead>
  <tbody>
    @if (loading) {
      <tr>
        <td colspan="7">
          <div class="cpo-table-loading">
            <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
          </div>
        </td>
      </tr>
    } @else {
      @for (
        item of this.dataSource.data;
        track item.id;
        let even = $even;
        let odd = $odd
      ) {
        @if (item.id != undefined) {
          <tr
            id="trsummary_{{ item.id }}"
            [ngClass]="{ even: even, odd: odd }"
            class="cpo-selectable-table__row"
            (click)="_selectRow_click(item.id)"
          >
            @if (!hideMID) {
              <td>
                {{ item.merchantLegalName }}<br />{{ item.mid }}
              </td>
            }
            @if (item.cardType == 'Other') {
              <td>
                ACH<br/>{{ item.cardFirst6 }}****{{ item.cardLast4 }}
              </td>
            } @else {
              <td>
                {{ item.cardType }}<br/>{{ item.cardFirst6 }}****{{ item.cardLast4 }}
              </td>
            }
            <td class="selectable">
              <span [innerHTML]="formatDate(item.date, '')"></span>
            </td>
            <td>{{ item.type }}</td>
            <td>{{ item.totalAmount }}</td>
            <td>
              {{ item.customerFirstName }} {{ item.customerLastName }}
            </td>
            <td>{{ item.successful ? 'Yes' : 'No' }}</td>
          </tr>
        }
        @if (this.options.selectAction == 'details') {
          <tr
            id="trdetails_{{ item.id }}"
            class="rowDetails noHover"
            style="display: none"
          >
            <td [attr.colspan]="hideMID ? 5 : 6">
              <div style="background-color: #ffffff; padding: 10px">
                <b>Transaction Details</b>
                <input
                  type="button"
                  value="Return"
                  [hidden]="
                    item.batchDate == '' ||
                    item.type != 'CAPTURE' || item.type != 'RECURRING'
                  "
                />
                <input
                  type="button"
                  value="Void"
                  [hidden]="
                    item.batchDate != '' ||
                    (item.type != 'CAPTURE' && item.type != 'RECURRING')
                  "
                />
              </div>
            </td>
          </tr>
        }
      }
    }
  </tbody>
</table>
